<div class="≈flex ≈justify-end ≈gap-2">
    <ng-content>

    </ng-content>
</div>